(() => {
  if (customElements.get('image-with-product-grid')) return;

  class ImageWithProductGrid extends HTMLElement {
    connectedCallback() {
      const count = parseInt(this.dataset.productCount || '0', 10);
      if (count <= 2) return;

      const el = this.querySelector('.iwpg__swiper');
      if (!el || typeof Swiper === 'undefined') return;

      const carouselId = `iwpg-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
      let nextBtn = this.querySelector('.swiper-button--next');
      let prevBtn = this.querySelector('.swiper-button--prev');

      if (nextBtn && !nextBtn.hasAttribute('data-carousel-id')) {
        nextBtn.setAttribute('data-carousel-id', carouselId);
        nextBtn.id = `next-${carouselId}`;
      }
      if (prevBtn && !prevBtn.hasAttribute('data-carousel-id')) {
        prevBtn.setAttribute('data-carousel-id', carouselId);
        prevBtn.id = `prev-${carouselId}`;
      }

      const nextEl =
        nextBtn && nextBtn.getAttribute('data-carousel-id') === carouselId
          ? `#next-${carouselId}`
          : null;
      const prevEl =
        prevBtn && prevBtn.getAttribute('data-carousel-id') === carouselId
          ? `#prev-${carouselId}`
          : null;

      const gapRoot = this.closest('.iwpg');
      let spaceBetween = 10;
      if (gapRoot) {
        const raw = getComputedStyle(gapRoot).getPropertyValue('--iwpg-slide-gap').trim();
        const px = parseInt(raw, 10);
        if (!Number.isNaN(px)) spaceBetween = px;
      }

      this.slider = new Swiper(el, {
        slidesPerView: 2,
        slidesPerGroup: 1,
        loop: true,
        spaceBetween,
        threshold: 4,
        watchOverflow: true,
        navigation: {
          nextEl,
          prevEl
        }
      });
    }

    disconnectedCallback() {
      if (this.slider && typeof this.slider.destroy === 'function') {
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }
  }

  customElements.define('image-with-product-grid', ImageWithProductGrid);
})();
